export const categoryArea = {
  goSearch: '7772.0 ',
  clickFeedGood: {
    spm: '7873.0',
    assembler() {
      const { good = {}, goodIndex } = this || {}
      const { sku_id: skuId, ssu_list: ssuList = [] } = good
      const [ssu = {}] = ssuList
      const { ssu_id: ssuId, status: goodsStatus } = ssu
      return {
        sku_id: skuId,
        ssu_id: ssuId,
        sku_pos: goodIndex,
        goods_status: goodsStatus
      }
    }
  },
  addCart: '7908.0',
  subscribe: '7909.0'
}
